module.exports = __webpack_public_path__ + "4038ed5f98203ea90eb09a12dfe19d93.MP3";